// extracted by mini-css-extract-plugin
export default {"container":"ShopView_container__G90dq","inner":"ShopView_inner__c46na","content":"ShopView_content__7kywi","closeButton":"ShopView_closeButton__dNaRe"};